import React, { Component } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css';
import { getAuthors, getCommentCounts, getTeaserImgSrc, isPremium, getLead, getTotalShareCount, getTitle, getTitleHeader, getUrl, getPublishingDate, getUpdatedDate } from '@ta-interaktiv/api-access';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_authors__Qdq4A.styles-module_authors__Qdq4A.styles-module_authors__Qdq4A.styles-module_authors__Qdq4A {\n  font-family: var(--infographic-font-stack);\n  padding-top: 0;\n  font-size: 0.9em;\n  margin-top: -0.5em;\n  line-height: 1.2em;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-box;\n  display: flex;\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n     -moz-box-align: baseline;\n          align-items: baseline;\n  -webkit-flex-wrap: wrap;\n          flex-wrap: wrap; }\n  .styles-module_authors__Qdq4A.styles-module_authors__Qdq4A.styles-module_authors__Qdq4A.styles-module_authors__Qdq4A > div {\n    margin-right: 1em;\n    margin-top: 0.5ex; }\n    .styles-module_authors__Qdq4A.styles-module_authors__Qdq4A.styles-module_authors__Qdq4A.styles-module_authors__Qdq4A > div:last-of-type {\n      margin-right: 0; }\n\n.styles-module_description__2U60d {\n  font-family: var(--infographic-font-stack);\n  color: var(--text-color); }\n\n.styles-module_titleHeader__3ilU3 {\n  font-family: var(--infographic-font-stack);\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--primary); }\n\n.styles-module_genre__fcXfS {\n  font-family: var(--infographic-font-stack);\n  font-weight: 600;\n  margin-right: 1ch;\n  float: left;\n  font-size: 0.95em;\n  text-rendering: geometricPrecision;\n  -webkit-transform: translateY(0.1ex);\n          transform: translateY(0.1ex); }\n\n.styles-module_moreLink__3JB7t {\n  color: var(--primary); }\n\n.styles-module_premiumMarker__iBhL8 {\n  -webkit-align-self: center;\n          align-self: center;\n  display: inline-block;\n  color: var(--primary);\n  font-family: var(--infographic-font-stack);\n  font-weight: 900;\n  border: 1px solid;\n  -webkit-border-radius: 2ch;\n          border-radius: 2ch;\n  line-height: 3ex;\n  padding: 0 1ch;\n  font-size: 0.66em;\n  text-transform: uppercase; }\n\n.styles-module_counts__3InRE {\n  font-size: 0.85em;\n  white-space: nowrap; }\n  .styles-module_counts__3InRE > span + span {\n    margin-left: 1ch; }\n";
var styles = {"authors":"styles-module_authors__Qdq4A","description":"styles-module_description__2U60d","titleHeader":"styles-module_titleHeader__3ilU3","genre":"styles-module_genre__fcXfS","moreLink":"styles-module_moreLink__3JB7t","premiumMarker":"styles-module_premiumMarker__iBhL8","counts":"styles-module_counts__3InRE"};
styleInject(css_248z);

function ArticleCard(_a) {
    var authors = _a.authors, _b = _a.className, className = _b === void 0 ? '' : _b, commentary = _a.commentary, commentaryIcon = _a.commentaryIcon, _c = _a.commentCount, commentCount = _c === void 0 ? 0 : _c, genre = _a.genre, imageSrc = _a.imageSrc, _d = _a.isPremium, isPremium = _d === void 0 ? false : _d, lead = _a.lead, openInNewWindow = _a.openInNewWindow, _e = _a.shareCount, shareCount = _e === void 0 ? 0 : _e, title = _a.title, titleHeader = _a.titleHeader, url = _a.url, _f = _a.locale, locale = _f === void 0 ? 'de' : _f;
    var numberFormatter = new Intl.NumberFormat(locale + "-CH", {
        notation: 'compact',
        compactDisplay: 'short',
        maximumSignificantDigits: 3
    }).format;
    return (React.createElement("a", { href: url, target: openInNewWindow ? '_blank' : '_top', onClick: function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'articleCard:' + url
            });
        }, className: "ui article-teaser card " + className },
        React.createElement("div", { className: 'image' },
            React.createElement("img", { alt: '', src: imageSrc })),
        React.createElement("div", { className: 'content' },
            React.createElement("div", { className: 'header' },
                titleHeader && (React.createElement("div", { className: styles.titleHeader }, titleHeader)),
                title),
            React.createElement("div", { className: "description " + styles.description },
                genre && (React.createElement("div", { className: styles.genre, style: { color: "#" + genre.color } }, genre.name)),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: lead } }))),
        React.createElement("div", { className: 'extra content ' + styles.authors },
            isPremium && React.createElement("div", { className: styles.premiumMarker }, "Abo"),
            authors && React.createElement("div", null, authors),
            React.createElement("div", { className: styles.counts },
                commentCount > 0 && (React.createElement("span", { className: styles.commentCount },
                    React.createElement("i", { className: 'comments outline icon' }),
                    numberFormatter(commentCount))),
                ' ',
                shareCount > 0 && (React.createElement("span", { className: styles.shareCount },
                    React.createElement("i", { className: 'share icon' }),
                    numberFormatter(shareCount))))),
        commentary && commentary !== '' && (React.createElement("div", { className: 'ui small info icon message commentary' },
            commentaryIcon && React.createElement("i", { className: "small " + commentaryIcon + " icon" }),
            React.createElement("div", { className: 'content', dangerouslySetInnerHTML: { __html: commentary } })))));
}

var SortMode;
(function (SortMode) {
    SortMode["NONE"] = "none";
    SortMode["MANUAL"] = "manual";
    SortMode["CHRONOLOGICALLY_BY_CREATION_DATE"] = "chronologically by creation date";
    SortMode["REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE"] = "reverse chronologically by creation date";
    SortMode["CHRONOLOGICALLY_BY_UPDATE_DATE"] = "chronologically by update date";
    SortMode["REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE"] = "reverse chronologically by update date";
    SortMode["SHARES"] = "shares";
    SortMode["REVERSE_SHARES"] = "reverse shares";
    SortMode["COMMENTS"] = "comments";
    SortMode["REVERSE_COMMENTS"] = "reverse comments";
})(SortMode || (SortMode = {}));

function getArticleTeaserData(domain, articleId) {
    return Promise.all([
        getAuthors(domain, articleId),
        getCommentCounts(domain, articleId),
        getTeaserImgSrc(domain, articleId, '800px'),
        isPremium(domain, articleId),
        getLead(domain, articleId),
        getTotalShareCount(domain, articleId),
        getTitle(domain, articleId),
        getTitleHeader(domain, articleId),
        getUrl(domain, articleId),
        getPublishingDate(domain, articleId),
        getUpdatedDate(domain, articleId)
    ])
        .then(function (_a) {
        var authors = _a[0], commentCount = _a[1], teaserImgSrc = _a[2], isPremium = _a[3], lead = _a[4], shareCount = _a[5], title = _a[6], titleHeader = _a[7], url = _a[8], publishingDateAsIsoString = _a[9], updatedDateAsIsoString = _a[10];
        return {
            authors: authors.join(', '),
            commentCount: commentCount,
            shareCount: shareCount !== null && shareCount !== void 0 ? shareCount : 0,
            imageSrc: teaserImgSrc,
            isPremium: isPremium !== null && isPremium !== void 0 ? isPremium : false,
            lead: lead !== null && lead !== void 0 ? lead : '',
            title: title !== null && title !== void 0 ? title : '',
            titleHeader: titleHeader,
            url: url,
            publishingDate: new Date(publishingDateAsIsoString).getTime(),
            updateDate: new Date(updatedDateAsIsoString).getTime(),
            id: articleId
        };
    })
        .catch(function (e) {
        console.warn("Article with ID " + articleId + " could not be loaded, due to " + e.name + ": " + e.message);
    });
}

var ArticleTeasers = (function (_super) {
    __extends(ArticleTeasers, _super);
    function ArticleTeasers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            downloadedArticles: new Map()
        };
        _this.hostdomain = _this.props.forceDomain || parseHostname().publicationName;
        return _this;
    }
    ArticleTeasers.prototype.render = function () {
        var _this = this;
        if (this.props.articleIds.length === 0 ||
            this.state.downloadedArticles.size === 0) {
            return null;
        }
        var sortedArticleList = [];
        this.props.articleIds.forEach(function (id) {
            var article = _this.state.downloadedArticles.get(id);
            if (article !== undefined) {
                sortedArticleList.push(article);
            }
        });
        if (sortedArticleList.length <= 0) {
            return null;
        }
        switch (this.props.sorting) {
            case SortMode.CHRONOLOGICALLY_BY_CREATION_DATE:
                sortedArticleList.sort(function (a, b) { return a.publishingDate - b.publishingDate; });
                break;
            case SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE:
                sortedArticleList.sort(function (a, b) { return b.publishingDate - a.publishingDate; });
                break;
            case SortMode.CHRONOLOGICALLY_BY_UPDATE_DATE:
                sortedArticleList.sort(function (a, b) { return a.updateDate - b.updateDate; });
                break;
            case SortMode.REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE:
                sortedArticleList.sort(function (a, b) { return b.updateDate - a.updateDate; });
                break;
            case SortMode.SHARES:
                sortedArticleList.sort(function (a, b) { var _a, _b; return ((_a = a.shareCount) !== null && _a !== void 0 ? _a : 0) - ((_b = b.shareCount) !== null && _b !== void 0 ? _b : 0); });
                break;
            case SortMode.REVERSE_SHARES:
                sortedArticleList.sort(function (a, b) { var _a, _b; return ((_a = b.shareCount) !== null && _a !== void 0 ? _a : 0) - ((_b = a.shareCount) !== null && _b !== void 0 ? _b : 0); });
                break;
            case SortMode.COMMENTS:
                sortedArticleList.sort(function (a, b) { var _a, _b; return ((_a = a.commentCount) !== null && _a !== void 0 ? _a : 0) - ((_b = b.commentCount) !== null && _b !== void 0 ? _b : 0); });
                break;
            case SortMode.REVERSE_COMMENTS:
                sortedArticleList.sort(function (a, b) { var _a, _b; return ((_a = b.commentCount) !== null && _a !== void 0 ? _a : 0) - ((_b = a.commentCount) !== null && _b !== void 0 ? _b : 0); });
                break;
            case SortMode.NONE:
            case SortMode.MANUAL:
        }
        return (React.createElement("div", { className: "article-teasers ui stackable " + this.props.numberOfCards + " " + this.props.className + " text cards" }, sortedArticleList.map(function (article) {
            if (typeof article.title === 'undefined') {
                return false;
            }
            return (React.createElement(ArticleCard, __assign({ key: article.id, locale: _this.props.locale, className: _this.props.itemClassName }, article)));
        })));
    };
    ArticleTeasers.prototype.componentDidMount = function () {
        var _this = this;
        this.props.articleIds.forEach(function (id) {
            _this.downloadNewArticle(id);
        });
    };
    ArticleTeasers.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        nextProps.articleIds.forEach(function (id) {
            if (_this.state.downloadedArticles.has(id)) {
                return;
            }
            _this.downloadNewArticle(id);
        });
    };
    ArticleTeasers.prototype.downloadNewArticle = function (articleID) {
        var _this = this;
        return getArticleTeaserData(this.hostdomain, articleID).then(function (data) {
            _this.setState(function (previousState) {
                var articleList = previousState.downloadedArticles;
                articleList.set(articleID, data);
                return __assign(__assign({}, previousState), { downloadedArticles: articleList });
            });
        });
    };
    ArticleTeasers.defaultProps = {
        numberOfCards: 'two',
        additionalClasses: '',
        className: '',
        itemClassName: '',
        sorting: SortMode.MANUAL,
        locale: 'de'
    };
    return ArticleTeasers;
}(Component));

export { ArticleCard, ArticleTeasers, SortMode, getArticleTeaserData };
//# sourceMappingURL=index.m.js.map
